<template>
  <div id='observeTable' class='h100vh-100'>
    <MonitObserveTableMenu @methodEnum='methodEnum'></MonitObserveTableMenu>
    <MonitObserveTable ref="monitObserveTable"></MonitObserveTable>
  </div>
</template>
<script>
import MonitObserveTableMenu from './MonitObserveTableMenu';
import MonitObserveTable from './MonitObserveTable';

export default {
  name: 'MonitObserveTaskList',
  components: {
    MonitObserveTableMenu,
    MonitObserveTable
  },
  data() {
    return {};
  },
  methods: {
    methodEnum(opcode) {
      this.$refs.monitObserveTable.queryConditions.status = opcode.value;
      this.$refs.monitObserveTable.getTrackListData();
    }
  }
};
</script>